import _ from "lodash"
import { ImdfFeature } from "providers/venue/types"

interface ILetterNameFirstOptions {
  pathToField?: string
  chosenLanguage: string
  fallbackLanguage?: string
}

const resolveName = (
  feature: ImdfFeature,
  path: string,
  lang: string,
  fallback: string
): string => {
  const value = _.get(feature, path) || {}
  const localised = value[lang]
  const fallbackVal = value[fallback]
  return (_.isEmpty(localised) ? fallbackVal : localised) ?? ""
}

// 0 = letter-led (A–Z, Thai, Chinese, etc.), 1 = digit-led (ASCII 0-9), 2 = empty
const leadingGroupRank = (name: string): number => {
  const trimmed = name.trimStart()
  if (!trimmed) return 2
  if (/\d/.test(trimmed[0])) return 1
  return 0
}

/** Returns a comparator function (a, b) => number that sorts features with
 *  letter-led names first, digit-led names next, and empty names last,
 *  using locale-aware alphabetical order within each group. */
export const createLetterNameFirstComparator =
  ({
    pathToField = "properties.name",
    chosenLanguage,
    fallbackLanguage = "en",
  }: ILetterNameFirstOptions) =>
  (a: ImdfFeature, b: ImdfFeature): number => {
    const an = resolveName(a, pathToField, chosenLanguage, fallbackLanguage)
    const bn = resolveName(b, pathToField, chosenLanguage, fallbackLanguage)
    const ar = leadingGroupRank(an)
    const br = leadingGroupRank(bn)
    if (ar !== br) return ar - br
    return an.localeCompare(bn, chosenLanguage, { numeric: true })
  }
